import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import TreatmentIntro from './TreatmentIntro';
import TreatmentDashboard from './TreatmentDashboard';

/**
 * For /treatment route only: show intro for guests, dashboard for logged-in users.
 * Sub-routes (/treatment/assess, etc.) remain protected in App.js.
 */
const TreatmentGateway = () => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated()) {
    return <TreatmentIntro />;
  }

  if (user?.role === 'Student') {
    return <Navigate to="/treatment/catalog" replace />;
  }

  return <TreatmentDashboard />;
};

export default TreatmentGateway;
